/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  CheckPaymentStatusAsOrder200Response,
  CheckPaymentStatusAsOrder400Response,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetOrder200Response,
  GetOrder400Response,
  PayOrder200Response,
  PayOrder400Response,
} from '../models/index'
import {
  CheckPaymentStatusAsOrder200ResponseFromJSON,
  CheckPaymentStatusAsOrder200ResponseToJSON,
  CheckPaymentStatusAsOrder400ResponseFromJSON,
  CheckPaymentStatusAsOrder400ResponseToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetOrder200ResponseFromJSON,
  GetOrder200ResponseToJSON,
  GetOrder400ResponseFromJSON,
  GetOrder400ResponseToJSON,
  PayOrder200ResponseFromJSON,
  PayOrder200ResponseToJSON,
  PayOrder400ResponseFromJSON,
  PayOrder400ResponseToJSON,
} from '../models/index'

export interface CheckPaymentStatusAsOrderRequest {
  paymentType: string
  productName: CheckPaymentStatusAsOrderProductNameEnum
  paymentStatus: string
  ownerSysObjectId: number
}

export interface GetOrderRequest {
  id: number
}

export interface PayOrderRequest {
  orderId: number
}

/**
 * OrdersApi - interface
 *
 * @export
 * @interface OrdersApiInterface
 */
export interface OrdersApiInterface {
  /**
   * Проверка наличия оплаты 1-й или 2-й пошлины по зТЗ: ищет заказ с продуктом пошлины и платежом указанного типа и статуса для объекта SysObject. Требуется подтверждённый email.
   * @summary Проверить оплату пошлины
   * @param {string} paymentType Тип платежа (Payment.type)
   * @param {'pervaya_poshlina' | 'vtoraya_poshlina'} productName Имя продукта пошлины
   * @param {string} paymentStatus Статус платежа (Payment.status)
   * @param {number} ownerSysObjectId Идентификатор объекта SysObject
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApiInterface
   */
  checkPaymentStatusAsOrderRaw(
    requestParameters: CheckPaymentStatusAsOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentStatusAsOrder200Response>>

  /**
   * Проверка наличия оплаты 1-й или 2-й пошлины по зТЗ: ищет заказ с продуктом пошлины и платежом указанного типа и статуса для объекта SysObject. Требуется подтверждённый email.
   * Проверить оплату пошлины
   */
  checkPaymentStatusAsOrder(
    requestParameters: CheckPaymentStatusAsOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentStatusAsOrder200Response>

  /**
   * Данные заказа по идентификатору (camelCase). Заказ не найден — код ERROR_GET_ORDER с 400. Требуется подтверждённый email.
   * @summary Получить заказ
   * @param {number} id Идентификатор заказа
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApiInterface
   */
  getOrderRaw(
    requestParameters: GetOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOrder200Response>>

  /**
   * Данные заказа по идентификатору (camelCase). Заказ не найден — код ERROR_GET_ORDER с 400. Требуется подтверждённый email.
   * Получить заказ
   */
  getOrder(
    requestParameters: GetOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOrder200Response>

  /**
   * Оплата существующего заказа текущего пользователя: создаёт платёж по указанному исполнителю платёжного шлюза. Требуется подтверждённый email.
   * @summary Оплатить заказ
   * @param {number} orderId Идентификатор заказа
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApiInterface
   */
  payOrderRaw(
    requestParameters: PayOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PayOrder200Response>>

  /**
   * Оплата существующего заказа текущего пользователя: создаёт платёж по указанному исполнителю платёжного шлюза. Требуется подтверждённый email.
   * Оплатить заказ
   */
  payOrder(
    requestParameters: PayOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PayOrder200Response>
}

/**
 *
 */
export class OrdersApi extends runtime.BaseAPI implements OrdersApiInterface {
  /**
   * Проверка наличия оплаты 1-й или 2-й пошлины по зТЗ: ищет заказ с продуктом пошлины и платежом указанного типа и статуса для объекта SysObject. Требуется подтверждённый email.
   * Проверить оплату пошлины
   */
  async checkPaymentStatusAsOrderRaw(
    requestParameters: CheckPaymentStatusAsOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentStatusAsOrder200Response>> {
    if (requestParameters['paymentType'] == null) {
      throw new runtime.RequiredError(
        'paymentType',
        'Required parameter "paymentType" was null or undefined when calling checkPaymentStatusAsOrder().'
      )
    }

    if (requestParameters['productName'] == null) {
      throw new runtime.RequiredError(
        'productName',
        'Required parameter "productName" was null or undefined when calling checkPaymentStatusAsOrder().'
      )
    }

    if (requestParameters['paymentStatus'] == null) {
      throw new runtime.RequiredError(
        'paymentStatus',
        'Required parameter "paymentStatus" was null or undefined when calling checkPaymentStatusAsOrder().'
      )
    }

    if (requestParameters['ownerSysObjectId'] == null) {
      throw new runtime.RequiredError(
        'ownerSysObjectId',
        'Required parameter "ownerSysObjectId" was null or undefined when calling checkPaymentStatusAsOrder().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/orders/check-payment-status-as-order/{paymentType}/{productName}/{paymentStatus}/{ownerSysObjectId}`
          .replace(
            `{${'paymentType'}}`,
            encodeURIComponent(String(requestParameters['paymentType']))
          )
          .replace(
            `{${'productName'}}`,
            encodeURIComponent(String(requestParameters['productName']))
          )
          .replace(
            `{${'paymentStatus'}}`,
            encodeURIComponent(String(requestParameters['paymentStatus']))
          )
          .replace(
            `{${'ownerSysObjectId'}}`,
            encodeURIComponent(String(requestParameters['ownerSysObjectId']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CheckPaymentStatusAsOrder200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Проверка наличия оплаты 1-й или 2-й пошлины по зТЗ: ищет заказ с продуктом пошлины и платежом указанного типа и статуса для объекта SysObject. Требуется подтверждённый email.
   * Проверить оплату пошлины
   */
  async checkPaymentStatusAsOrder(
    requestParameters: CheckPaymentStatusAsOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentStatusAsOrder200Response> {
    const response = await this.checkPaymentStatusAsOrderRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Данные заказа по идентификатору (camelCase). Заказ не найден — код ERROR_GET_ORDER с 400. Требуется подтверждённый email.
   * Получить заказ
   */
  async getOrderRaw(
    requestParameters: GetOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOrder200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getOrder().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/orders/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetOrder200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Данные заказа по идентификатору (camelCase). Заказ не найден — код ERROR_GET_ORDER с 400. Требуется подтверждённый email.
   * Получить заказ
   */
  async getOrder(
    requestParameters: GetOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOrder200Response> {
    const response = await this.getOrderRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Оплата существующего заказа текущего пользователя: создаёт платёж по указанному исполнителю платёжного шлюза. Требуется подтверждённый email.
   * Оплатить заказ
   */
  async payOrderRaw(
    requestParameters: PayOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PayOrder200Response>> {
    if (requestParameters['orderId'] == null) {
      throw new runtime.RequiredError(
        'orderId',
        'Required parameter "orderId" was null or undefined when calling payOrder().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/orders/pay/{orderId}`.replace(
          `{${'orderId'}}`,
          encodeURIComponent(String(requestParameters['orderId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PayOrder200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Оплата существующего заказа текущего пользователя: создаёт платёж по указанному исполнителю платёжного шлюза. Требуется подтверждённый email.
   * Оплатить заказ
   */
  async payOrder(
    requestParameters: PayOrderRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PayOrder200Response> {
    const response = await this.payOrderRaw(requestParameters, initOverrides)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum CheckPaymentStatusAsOrderProductNameEnum {
  PervayaPoshlina = 'pervaya_poshlina',
  VtorayaPoshlina = 'vtoraya_poshlina',
}
